// Robust modal handler (capture-phase) — closes on any click outside the panel
(function() {
  const MODAL_ID = 'warranty-modal';
  const PANEL_SEL = '.warranty-modal__panel';
  const OPEN_TRIGGER_SEL = '#warranty-learn-more-link';
  let clickCaptureHandler = null;

  function getFocusable(el) {
    return el.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
  }

  function openModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    const trigger = document.querySelector(OPEN_TRIGGER_SEL);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    modal.__lastActive = document.activeElement;
    const focusable = getFocusable(modal);
    if (focusable && focusable.length) focusable[0].focus();
    document.documentElement.style.overflow = 'hidden';

    // attach capture-phase click listener to detect clicks outside panel reliably
    if (!clickCaptureHandler) {
      clickCaptureHandler = function(ev) {
        try {
          const panel = modal.querySelector(PANEL_SEL);
          if (!panel) return;
          // if click target is inside panel -> ignore
          if (panel.contains(ev.target)) return;
          // otherwise close modal (stop propagation so theme handlers don't run)
          ev.stopPropagation();
          ev.preventDefault();
          closeModal();
        } catch (err) {
          console.error('Modal capture handler error', err);
        }
      };
      // use capture so we get the event before other listeners that might stop it
      document.documentElement.addEventListener('click', clickCaptureHandler, true);
    }
  }

  function closeModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    const trigger = document.querySelector(OPEN_TRIGGER_SEL);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    const last = modal.__lastActive;
    if (last && last.focus) last.focus();
    document.documentElement.style.overflow = '';

    // remove the capture listener
    if (clickCaptureHandler) {
      document.documentElement.removeEventListener('click', clickCaptureHandler, true);
      clickCaptureHandler = null;
    }
  }

  // click handlers for open/close buttons (bubble-phase fine)
  document.addEventListener('click', function(e) {
    const open = e.target.closest && e.target.closest(OPEN_TRIGGER_SEL);
    if (open) {
      e.preventDefault();
      openModal();
      return;
    }
    // close button / overlay close via attributes
    if (e.target.closest && (e.target.closest('[data-modal-close]') || e.target.closest('.warranty-modal__close'))) {
      e.preventDefault();
      closeModal();
      return;
    }
  });

  // ESC and focus trap
  document.addEventListener('keydown', function(e) {
    const modal = document.getElementById(MODAL_ID);
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
      return;
    }

    if (e.key === 'Tab') {
      const focusable = Array.from(getFocusable(modal));
      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          last.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    }
  });

  // small debug: log clicks when modal is open (optional)
  // remove/comment out in production if you prefer no console noise
  document.addEventListener('click', function(e) {
    const modal = document.getElementById(MODAL_ID);
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
    console.debug('Modal open — click target:', e.target);
  }, true);
})();

// warranty-serialized-fix.js
// Detects Ruby-style serialized rich-text object in #warranty-modal-content
// Converts to JSON, renders HTML (headings, paragraphs, lists, text with bold/italic).
// Paste at the end of assets/warranty.js or inline in the snippet inside <script>.

(function () {
  function textNodeToHtml(node) {
    // node may be { type: 'text', value: '...' , bold: true, italic: true }
    var t = document.createElement('span');
    var txt = document.createTextNode(node.value || '');
    t.appendChild(txt);
    if (node.bold) {
      var b = document.createElement('strong');
      b.appendChild(t);
      t = b;
    }
    if (node.italic) {
      var i = document.createElement('em');
      i.appendChild(t);
      t = i;
    }
    return t;
  }

  function renderNode(node) {
    if (!node || !node.type) return document.createTextNode('');
    switch (node.type) {
      case 'root': {
        var frag = document.createDocumentFragment();
        (node.children || []).forEach(function (c) {
          frag.appendChild(renderNode(c));
        });
        return frag;
      }
      case 'heading': {
        var lvl = node.level || 2;
        var el = document.createElement('h' + (Math.min(Math.max(lvl,1),6)));
        (node.children || []).forEach(function (c) { el.appendChild(renderNode(c)); });
        return el;
      }
      case 'paragraph': {
        var p = document.createElement('p');
        (node.children || []).forEach(function (c) { p.appendChild(renderNode(c)); });
        return p;
      }
      case 'list': {
        var listType = node.listType === 'ordered' ? 'ol' : 'ul';
        var ul = document.createElement(listType);
        (node.children || []).forEach(function (li) {
          var liEl = document.createElement('li');
          // list-item children may be an array of nodes
          (li.children || []).forEach(function (c) { liEl.appendChild(renderNode(c)); });
          ul.appendChild(liEl);
        });
        return ul;
      }
      case 'list-item': {
        var li = document.createElement('li');
        (node.children || []).forEach(function (c) { li.appendChild(renderNode(c)); });
        return li;
      }
      case 'text': {
        return textNodeToHtml(node);
      }
      case 'blockquote': {
        var bq = document.createElement('blockquote');
        (node.children || []).forEach(function (c) { bq.appendChild(renderNode(c)); });
        return bq;
      }
      default: {
        // unknown node -> render children
        var frag = document.createDocumentFragment();
        (node.children || []).forEach(function (c) { frag.appendChild(renderNode(c)); });
        return frag;
      }
    }
  }

  function tryParseSerialized(str) {
    // Convert Ruby-like serialization to JSON-like:
    // Replace => or "=>" with ":" (handles variants), then try parse.
    try {
      // normalize HTML entities already present (e.g., &nbsp;) left as-is
      var jsonish = str
        .replace(/\"?=>\"?/g, '":')   // handle "=>" or "'=>"
        .replace(/=>/g, ':')         // any remaining =>
        .replace(/:([A-Za-z0-9_]+)/g, function(m, p1) {
          // ensure property names are quoted if left unquoted (rare)
          return ':"' + p1 + '"';
        });

      // Also ensure keys are quoted properly — the serialized dump likely already has "key" but do a safe fix:
      // If still invalid JSON, try to coerce by replacing single quotes with double quotes
      jsonish = jsonish.replace(/:nil\b/g, ':null'); // ruby nil -> null
      // Remove Ruby hashroket spacing style? keep as is.

      // try parse
      return JSON.parse(jsonish);
    } catch (err) {
      // fallback: try a looser transform: replace '=>' with ':' then wrap keys with quotes via regex
      try {
        var alt = str.replace(/=>/g, ':');
        // replace pattern {key: with {"key":
        alt = alt.replace(/([{,]\s*)([A-Za-z0-9_]+)\s*:/g, '$1"$2":');
        alt = alt.replace(/:nil\b/g, ':null');
        return JSON.parse(alt);
      } catch (err2) {
        return null;
      }
    }
  }

  function handleWarrantyModalContent() {
    var content = document.getElementById('warranty-modal-content');
    if (!content) return;

    // If textContent looks like a Ruby serialized structure, try parse & render
    var text = content.textContent || '';
    if (!text) return;

    // crude detection: contains => or "children"
    if (text.indexOf('=>') === -1 && text.indexOf('"children"') === -1 && text.indexOf('children') === -1) return;

    // Try converting & parsing
    var parsed = tryParseSerialized(text);
    if (!parsed) {
      // nothing we can do — hide the dump and show a fallback safe message
      content.innerHTML = '<h2 id="warranty-modal-title">SwingCare™ Protection Plan</h2><p>Details coming soon — please contact support for warranty information.</p>';
      return;
    }

    // parsed should be the structured object
    try {
      var node = parsed;
      var dom = renderNode(node);
      // replace content
      content.innerHTML = '';
      content.appendChild(dom);
      return;
    } catch (err) {
      content.innerHTML = '<h2 id="warranty-modal-title">SwingCare™ Protection Plan</h2><p>Details coming soon — please contact support for warranty information.</p>';
      return;
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleWarrantyModalContent);
  } else {
    handleWarrantyModalContent();
  }

  // Also observe in case the modal content is inserted later dynamically
  var observer = new MutationObserver(function () {
    handleWarrantyModalContent();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
